
        var result = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/lib/loader.js!./storage-profile.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/storage-profile/storage-profile.scss
// module id = 2uJC
// module chunks = 0